import { render, staticRenderFns } from "./PurchasingOrderList.vue?vue&type=template&id=122da681&"
import script from "./PurchasingOrderList.vue?vue&type=script&lang=js&"
export * from "./PurchasingOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports